module.exports = __webpack_public_path__ + "static/media/app-logo.ead3c4fc.png";